// extracted by mini-css-extract-plugin
export default {"text":"r5lsJ1c8"};